import { render, staticRenderFns } from "./RegistrationBuilder.vue?vue&type=template&id=1165a1a4&scoped=true"
import script from "./RegistrationBuilder.vue?vue&type=script&lang=js"
export * from "./RegistrationBuilder.vue?vue&type=script&lang=js"
import style0 from "./RegistrationBuilder.vue?vue&type=style&index=0&id=1165a1a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1165a1a4",
  null
  
)

export default component.exports